/**
 * Created by Andrey on 21.10.2026.
 */

// Paid impressions of ads the game did not start. A farm plays ads behind the game's back, so its impressions come while
// no ad of ours runs and have no placement (adcost-undefined). fairy android 09.2026: every farm install had 3 or more
// such impressions in a row, players with a real impression in between 0 of 3084. An impression of our own ad resets
class UnplacedAdsFraud extends cleverapps.EventEmitter {
    constructor() {
        super();

        this.config = {
            threshold: 3
        };

        connector.ads.on("rewarded:impression", () => this.onImpression("rewarded"));
        connector.ads.on("interstitial:impression", () => this.onImpression("interstitial"));
    }

    onImpression() {
        this.trigger(cleverapps.rewardedAdsManager.getRunningAdLimit() ? "reset" : "hit");
    }
}
